export enum StatusType {
  Active = 'Active',
  InActive = 'InActive',
  Pending = 'Pending',
}
